import keyBy from 'lodash/keyBy';
import uniqueId from 'lodash/uniqueId';

export default function create(
    action: CreateFolderAction,
    setFolders: React.Dispatch<React.SetStateAction<{[localId: string]: Folder}>>
) {
    const data = !action.data
        ? [createFolder()]
        : (Array.isArray(action.data) ? action.data : [action.data]).map(createFolder);

    setFolders((latestFolders) => ({
        ...latestFolders,
        ...keyBy(data, (folder) => folder.localId),
    }));

    if (action.callback) {
        action.callback(data[0]);
    }

    return data.map((folder) => folder.localId);
}

export function createFolder(folder?: Partial<FolderSummary> | Partial<Folder>): Folder {
    return {
        ...folder,
        localId: folder?.id || uniqueId('folder'),
        title: folder?.title || 'Untitled Folder',
        notes: folder?.notes || '',
        time_created: folder?.time_created || new Date().toISOString(),
        updated_date: folder?.updated_date || new Date().toISOString(),
        folder: folder?.folder,
        archived: false,
        type: 'folder',
        public: false,
        writable: true,
    };
}
